import { AnomalyEvent, AnomalyLabel } from './types';
export type Filters = {
  search: string;
  family: string;
  status: string;
  labelId: string;
  days: string;
};
export const initialFilters: Filters = {
  search: '',
  family: 'all',
  status: 'pending',
  labelId: 'all',
  days: 'all',
};
export function resolveLabel(id: string | null, labels: AnomalyLabel[]): AnomalyLabel | undefined {
  const seen = new Set<string>();
  let label = labels.find((item) => item.id === id);
  while (label?.mergedInto && !seen.has(label.id)) {
    seen.add(label.id);
    label = labels.find((item) => item.id === label!.mergedInto);
  }
  return label;
}
export function filterEvents(
  events: AnomalyEvent[],
  labels: AnomalyLabel[],
  filters: Filters,
  now = Date.now()
) {
  const search = filters.search.trim().toLocaleLowerCase('da-DK');
  return events.filter((event) => {
    const label = resolveLabel(event.review.labelId, labels);
    return (
      (filters.status === 'all' || event.review.status === filters.status) &&
      (filters.family === 'all' || event.deviceFamily === filters.family) &&
      (filters.labelId === 'all' || label?.id === filters.labelId) &&
      (filters.days === 'all' || event.occurredAt >= now - Number(filters.days) * 86400000) &&
      (!search ||
        [
          event.sensorTitle,
          event.orgTitle,
          event.deviceId,
          event.title,
          event.review.note,
          label?.name || '',
        ]
          .join(' ')
          .toLocaleLowerCase('da-DK')
          .includes(search))
    );
  });
}
export const dateTime = (at: number) =>
  new Intl.DateTimeFormat('da-DK', {
    dateStyle: 'medium',
    timeStyle: 'short',
    timeZone: 'Europe/Copenhagen',
  }).format(at);
export const number = (value: number) =>
  new Intl.NumberFormat('da-DK', { maximumFractionDigits: 1 }).format(value);
